export const slidersData: any = [
  {
    id: 'material',
    name: 'Material Settings',
    items: [
      // {
      //   id: 'blend',
      //   name: 'Blend',
      //   type: 'picker',
      //   groupId: 'material',
      //   options: ['Alpha', 'Premultiply', 'Additive', 'Multiply'],
      //   order: 0,
      //   defaultValue: 'Alpha',
      // },
      {
        id: 'metalness',
        name: 'Metalness',
        type: 'slider',
        groupId: 'material',
        order: 0,
        defaultValue: 0,
        config: {
          min: 0,
          max: 1,
        },
      },
      {
        id: 'roughness',
        name: 'Roughness',
        type: 'slider',
        groupId: 'material',
        order: 0,
        defaultValue: 0.5,
      },
      {
        id: 'specular',
        name: 'Specular',
        type: 'slider',
        groupId: 'material',
        order: 0,
        defaultValue: 0.5,
      },
      {
        id: 'transparency',
        name: 'Transparency',
        type: 'slider',
        groupId: 'material',
        order: 0,
        defaultValue: 0.5,
      },
      // {
      //   id: 'alphaClip',
      //   name: 'Alpha Clip',
      //   type: 'slider',
      //   groupId: 'material',
      //   order: 0,
      //   defaultValue: 0.0,
      // },
      {
        id: 'normalStrength',
        name: 'Normal Strength',
        type: 'slider',
        groupId: 'material',
        order: 0,
        defaultValue: 1.0,
        config: {
          min: 0,
          max: 10,
          step: 0.1,
        },
      },
      // {
      //   id: 'emission',
      //   name: 'Emission',
      //   type: 'slider',
      //   groupId: 'material',
      //   order: 0,
      //   defaultValue: 0.5,
      // },
    ],
  },
];
